import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';
import {LocalstorageService} from '@services/localstorage.service';
import {AuthService} from '../auth/auth.service';
import {UserProfileService} from '@services/user-profile.service';
import {isUnauthorizedRoute} from '../auth/functions/funcAuth';

const LOGIN_URL = '/login/bem-vindo';
const SELECT_CONTRACT_URL = '/selecionar-contrato';

const PREPAID_MODALITY_ID = 1;

type RouteData = {
  roles?: string;            // roles.ts padrão (cliente/parceiro)
  backofficeRoles?: string;  // roles.ts específicas de backoffice
  contractRequired?: boolean;
  prepaidPage?: boolean;
};

function hasSelectedContract(id: string | null | undefined): boolean {
  return !!id && id !== '0' && id.trim().length > 0;
}

export const authCustomerGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
  const { roles: customerRoles = '', backofficeRoles, contractRequired = false, prepaidPage = false } = (route.data as RouteData) ?? {};

  const router: Router = inject(Router);
  const oauthService: OAuthService = inject(OAuthService);
  const localstorageService: LocalstorageService = inject(LocalstorageService);
  const userProfileService: UserProfileService = inject(UserProfileService);
  const authService: AuthService = inject(AuthService);

  if (!oauthService.hasValidAccessToken()) {
    await router.navigateByUrl(LOGIN_URL);
    return false;
  }

  const profile: number = userProfileService.getUserProfile();
  const isCustomer: boolean = userProfileService.isCustomerOrRelationshipProfile();
  const isBackoffice: boolean = userProfileService.isBackOffice();

  if (isUnauthorizedRoute(state.url, profile) && (isCustomer || isBackoffice)) {
    return true;
  }

  if (!isCustomer && !isBackoffice) {
    await router.navigateByUrl(authService.getUrlUnAuthorized());
    return false;
  }

  const contractId: string = isBackoffice ? localstorageService.getSessionStorageContractId() : localstorageService.getContractId();
  if (contractRequired && !hasSelectedContract(contractId)) {
    await router.navigateByUrl(SELECT_CONTRACT_URL);
    return false;
  }

  const modalityId: number = isBackoffice ? Number(authService.getContractModalityTypeId()) : Number(localstorageService.getContractModalityTypeId());
  if (prepaidPage && modalityId !== PREPAID_MODALITY_ID) {
    await router.navigateByUrl(authService.getUrlUnAuthorized());
    return false;
  }

  const rolesToCheck: string = isBackoffice ? (backofficeRoles ?? customerRoles) : customerRoles;
  return authService.checkRolesByUserLogged(rolesToCheck);
};
